export default "__VITE_ASSET__Bcr4EZpH__"